var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
export class IntegrationDialogState {
    constructor() {
        this.show = false;
        this.left = 100;
        this.top = 100;
        this.loading = false;
        this.integrations = new Map();
        this.loadstage = -1;
        this.add = false;
        this.adding = false;
        this.deletids = new Set();
        this.editid = "";
        this.schemaitems = [];
        this.schemaid = "";
        this.letrid = "";
        makeObservable(this);
        APPEvent.addSubscriberForGetIntegrations((ints) => {
            console.log(ints);
            ints.forEach((int) => {
                if (int.schemaid === this.schemaid) {
                    this.setIntegration(int);
                }
            });
            this.setLoading(false);
        });
        APPEvent.addSubscriberForAddIntegrations((ints) => {
            if (ints) {
                if (ints.schemaid === this.schemaid) {
                    this.setIntegration(ints);
                    if (this.editid === (ints === null || ints === void 0 ? void 0 : ints.id)) {
                        this.setEditId("");
                    }
                }
            }
            else {
                APPEvent.publishApperror("Sorry, failed to save integration");
            }
            this.setAdding(false);
            this.setAdd(false);
        });
        APPEvent.addSubscriberForDeleteIntegrations((res) => {
            if (this.deletids.has(res.id)) {
                if (res.ok) {
                    this.deleteIntegration(res.id);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to delete integration");
                }
                this.removeFromDel(res.id);
            }
        });
    }
    setEditId(id) {
        this.editid = id;
    }
    setAdd(add) {
        this.add = add;
    }
    setAdding(add) {
        this.adding = add;
    }
    deleteInt(id) {
        const oin = this.integrations.get(id);
        if (!oin)
            return;
        this.addToDel(id);
        Apphandler.sendMessage("deleteintegration", oin);
    }
    loadIntegration() {
        if (this.loading || this.loadstage === 1)
            return;
        this.setLoading(true);
        const resp = {
            schemaid: this.schemaid,
            letrid: this.letrid
        };
        Apphandler.sendMessage("getintegrations", resp);
    }
    setShow(show) {
        this.show = show;
        if (this.show) {
            this.loadIntegration();
        }
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setLeft(left) {
        this.left = left;
    }
    setTop(top) {
        this.top = top;
    }
    setIntegration(inter) {
        this.integrations.set(inter.id, inter);
    }
    deleteIntegration(id) {
        this.integrations.delete(id);
    }
    reset() {
        this.integrations.clear();
        this.loadstage = -1;
        this.setAdd(false);
        this.deletids.clear();
    }
    addToDel(id) {
        this.deletids.add(id);
    }
    removeFromDel(id) {
        this.deletids.delete(id);
    }
    addIntegration(int, name, type) {
        const model = {
            name: name,
            id: this.editid !== '' ? this.editid : "",
            typs: type,
            schemaid: this.schemaid,
            letrid: this.letrid,
            config: int
        };
        Apphandler.sendMessage(this.editid !== '' ? "updateintegration" : "addintegration", model);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], IntegrationDialogState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IntegrationDialogState.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IntegrationDialogState.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IntegrationDialogState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], IntegrationDialogState.prototype, "integrations", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IntegrationDialogState.prototype, "loadstage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IntegrationDialogState.prototype, "add", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IntegrationDialogState.prototype, "adding", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], IntegrationDialogState.prototype, "deletids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IntegrationDialogState.prototype, "editid", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "setEditId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "setAdd", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "setAdding", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "setIntegration", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "deleteIntegration", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "addToDel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], IntegrationDialogState.prototype, "removeFromDel", null);
